<template>
    <renderless-laravel-vue-pagination :data="data" :limit="limit" :show-disabled="showDisabled" v-on:pagination-change-page="onPaginationChangePage">
        <ul class="pagination" v-if="computed.total > computed.perPage" slot-scope="{ data, limit, computed, prevButtonEvents, nextButtonEvents, pageButtonEvents }">
            <li class="page-item pagination-prev-nav" :class="{'disabled': !computed.prevPageUrl}" v-if="computed.prevPageUrl || showDisabled">
                <a class="page-link" href="#" aria-label="Previous" :tabindex="!computed.prevPageUrl && -1" v-on="prevButtonEvents">
                    <slot name="prev-nav">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                height="24" width="24" fill="currentColor"
                                aria-hidden="true" focusable="false"
                                style="height: 1.5em; width: 1.5em">
                            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
                        </svg>
                        <span class="text-uppercase d-none d-md-inline">{{ __('Previous') }}</span>
                    </slot>
                </a>
            </li>
            <li class="page-item" v-for="(page, key) in computed.pageRange" :key="key" :class="[{ 'active': page == computed.currentPage }, page === '...' ? 'pagination-range' : 'pagination-page-nav']">
                <span v-if="page === '...'" class="page-link">{{ page }}</span>
                <a v-else class="page-link" href="#" v-on="pageButtonEvents(page)">{{ page }}</a>
            </li>
            <li class="page-item pagination-next-nav" :class="{'disabled': !computed.nextPageUrl}" v-if="computed.nextPageUrl || showDisabled">
                <a class="page-link" href="#" aria-label="Next" :tabindex="!computed.nextPageUrl && -1" v-on="nextButtonEvents">
                    <slot name="next-nav">
                        <span class="text-uppercase d-none d-md-inline">{{ __('Next') }}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                height="24" width="24" fill="currentColor"
                                aria-hidden="true" focusable="false"
                                style="height: 1.5em; width: 1.5em">
                            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
                        </svg>
                    </slot>
                </a>
            </li>
        </ul>
    </renderless-laravel-vue-pagination>
</template>

<script>
    import trans from '../mixins/trans';
    import RenderlessLaravelVuePagination from './RenderlessLaravelVuePagination.vue';

    export default {
        mixins: [
            trans
        ],

        props: {
            data: {
                type: Object,
                default: () => {}
            },
            limit: {
                type: Number,
                default: 0
            },
            showDisabled: {
                type: Boolean,
                default: true
            }
        },
        methods: {
            onPaginationChangePage (page) {
                this.$emit('pagination-change-page', page);
            }
        },
        components: {
            RenderlessLaravelVuePagination
        }
    }
</script>